import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiMap, FiMapPin, FiUsers, FiVideo, FiImage, FiHome } from 'react-icons/fi';

const TITLE_SITE_PUBLICO = 'SITE OFICIAL - NETALIMATURISMO';

const PublicLayout = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    document.title = TITLE_SITE_PUBLICO;
  }, [location.pathname]);

  const menuItems = [
    { path: '/', label: 'Início', icon: FiHome },
    { path: '/viagens', label: 'Viagens', icon: FiMap },
    { path: '/mapa', label: 'Mapa de Destinos', icon: FiMapPin },
    { path: '/quem-somos', label: 'Quem Somos', icon: FiUsers },
    { path: '/galeria-videos', label: 'Galeria de Vídeos', icon: FiVideo },
    { path: '/galeria-fotos', label: 'Galeria de Fotos', icon: FiImage },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/logo-netalima.png" 
                alt="Neta Lima Turismo" 
                className="h-20 w-auto object-contain"
              />
              <div className="hidden sm:block">
                <p className="text-sky-600 font-medium italic text-sm md:text-base">
                  {'"Guiando sonhos, criando memórias."'}
                </p>
              </div>
            </Link>

            {/* Desktop Menu */}
            <nav className="hidden lg:flex items-center space-x-1">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center px-3 py-2 rounded-lg transition-colors whitespace-nowrap text-sm ${
                      isActive
                        ? 'bg-sky-100 text-sky-700 font-medium'
                        : 'text-gray-700 hover:bg-sky-50 hover:text-sky-600'
                    }`}
                  >
                    <Icon className="mr-1.5" size={16} />
                    {item.label}
                  </Link>
                );
              })}
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 text-gray-700"
            >
              {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 bg-white">
            <nav className="px-4 py-4 space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-sky-100 text-sky-700 font-medium'
                        : 'text-gray-700 hover:bg-sky-50'
                    }`}
                  >
                    <Icon className="mr-3" size={20} />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main>{children}</main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-sky-800 to-sky-900 text-white mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <img 
                src="/logo-netalima.png" 
                alt="Neta Lima Turismo" 
                className="h-12 w-auto object-contain mb-4 brightness-0 invert"
              />
              <p className="text-sky-200">
                Sua melhor escolha para viagens inesquecíveis. Conforto, segurança e qualidade em cada destino.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Links Rápidos</h3>
              <ul className="space-y-2 text-sky-200">
                {menuItems.map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="hover:text-yellow-400 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Contato</h3>
              <p className="text-sky-200">
                Entre em contato conosco para mais informações sobre nossos pacotes e serviços.
              </p>
            </div>
          </div>
          <div className="border-t border-sky-700 mt-8 pt-8 text-center text-sky-300">
            <p>&copy; {new Date().getFullYear()} NetalimaTurismo. Todos os direitos reservados.</p>
            <p className="mt-3 text-sm text-sky-300 px-2">
              <a
                href="/politica-privacidade.html"
                className="hover:text-yellow-400 transition-colors"
              >
                Política de Privacidade
              </a>
              {' | CNPJ - 61.816.407/0001-86 | Empresa na Cadastur - 10.420512.70-7'}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
